import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-soc-m-storeautonomousmarketinggroup",
  "use": "icon-soc-m-storeautonomousmarketinggroup-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-soc-m-storeautonomousmarketinggroup\">\r\n<g transform=\"translate(-80 -80) scale(1.18)\" fill=\"currentColor\">\r\n<circle cx=\"420\" cy=\"180\" r=\"28\" /><path d=\"M192 256h640v448H576l-64 128-64-128H192V256z\" /><path d=\"M320 384h384v48H320zM320 480h256v48H320z\" fill=\"#fff\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/soc-m-storeautonomousmarketinggroup.svg
// module id = cF/7
// module chunks = 546